module.exports = __webpack_public_path__ + "img/Simon_Electronic_Game.3e06e771.jpg";